import { ensure, SprintQueryResult, useSprintQuery } from "sprint-common-web";

import { OnPremAssetQueryKey } from "../../../../assets/details/on-prem-asset/common/OnPremAssetQueryKey";
import { useAssetsApi } from "../../../../common/api/master-api/assets/useAssetsApi";
import { AssetOperationListItem, mapToAssetOperationListItem } from "../AssetOperationListItem";

export const useOnPremAssetOperations = (fileRecordId?: string): SprintQueryResult<AssetOperationListItem[]> => {
    const { getOnPremAssetsOperations } = useAssetsApi();

    return useSprintQuery<AssetOperationListItem[]>({
        queryKey: [OnPremAssetQueryKey.OnPremAssetOperations, fileRecordId],
        queryFn: async (): Promise<AssetOperationListItem[]> => {
            try {
                ensure(fileRecordId, "File Record ID is required to fetch on-prem asset operations.");

                const response = await getOnPremAssetsOperations({ fileRecordId });

                return response.items.map(mapToAssetOperationListItem);
            } catch (error) {
                console.error("Failed to fetch on-prem asset operations.", error);

                return [];
            }
        },
        options: {
            cacheTime: 0
        }
    });
};
